import axios from 'axios';

const axiosInstance5000 = axios.create({
  baseURL: 'https://ussalescoachfrontend-api-app-aihhyoej2q-ue.a.run.app',
});

export default axiosInstance5000;
